// ============================================================================
// TIPOS DE ENTRADA (Entry)
// ============================================================================

/** Estados de la entrada */
export type EntryStatus =
  | 'PENDIENTE'
  | 'EN_RECEPCION'
  | 'EN_RECEPCION_PARCIAL'
  | 'FINALIZADA'
  | 'SIN_IDENTIFICAR'
  | 'CANCELADA';

/** Team asociado a la entrada */
export interface EntryTeam {
  id: number;
  name: string;
}

/** User asociado a la entrada */
export interface EntryUser {
  id: number;
  name: string;
}

/** Entrada de mercancía */
export interface Entry {
  id: number;
  user_id: number;
  team_id: number;
  reference: string;
  status: EntryStatus;
  estimated_delivery_at: string | null;
  boxes_count: number | null;
  tracking_code: string | null;
  metadata: Record<string, any> | null;
  created_at: string;
  updated_at: string;
  team?: EntryTeam;
  user?: EntryUser;
}

/** Respuesta paginada de entradas */
export interface EntriesApiResponse {
  data: Entry[];
  meta: {
    current_page: number;
    per_page: number;
    total: number;
    last_page: number;
  };
}

/** Labels para los estados de entrada */
export const ENTRY_STATUS_LABELS: Record<EntryStatus, string> = {
  PENDIENTE: 'Pendiente',
  EN_RECEPCION: 'En recepción',
  EN_RECEPCION_PARCIAL: 'Recepción Parcial',
  FINALIZADA: 'Finalizada',
  SIN_IDENTIFICAR: 'Sin identificar',
  CANCELADA: 'Cancelada',
};

